import { render, staticRenderFns } from "./CommunityInfrastructureDetails.vue?vue&type=template&id=0637e441&scoped=true&"
import script from "./CommunityInfrastructureDetails.vue?vue&type=script&lang=js&"
export * from "./CommunityInfrastructureDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommunityInfrastructureDetails.vue?vue&type=style&index=0&id=0637e441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637e441",
  null
  
)

export default component.exports